import { render, staticRenderFns } from "./breathDetail.vue?vue&type=template&id=11cd4914"
import script from "./breathDetail.vue?vue&type=script&lang=js"
export * from "./breathDetail.vue?vue&type=script&lang=js"
import style0 from "./breathDetail.vue?vue&type=style&index=0&id=11cd4914&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports